import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';

import { toI18n } from 'util/i18n';

export const BillingSettingsAddonsCancellation = () => (
  <Box inline>
    <Text>
      {toI18n(
        'settings.pages.billing.addons_cancellation.ctc_outside_business_hours.start_copy'
      )}{' '}
      <Link href="/help">
        {toI18n(
          'settings.pages.billing.addons_cancellation.ctc_outside_business_hours.help_center'
        )}
      </Link>
      {toI18n(
        'settings.pages.billing.addons_cancellation.ctc_outside_business_hours.end_copy'
      )}
    </Text>
  </Box>
);

export default BillingSettingsAddonsCancellation;
